import { TemperatureUnits } from "./TemperatureUnits";
import { Unit } from "./Unit";
import { NumberWithUnit, NumberWithUnitConstructor } from "./NumberWithUnit";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";

export class Temperature extends NumberWithUnit {
    protected override get cls(): NumberWithUnitConstructor {
        return Temperature;
    }

    public override get unitGroup(): TemperatureUnits {
        return TemperatureUnits.singleton;
    }

    public override convert(targetUnit: Unit): number {
        if ((this.unit === TemperatureUnits.FAHRENHEIT && targetUnit === TemperatureUnits.CELSIUS)) {
            return (this.number - 32) * (5 / 9);
        }
        if ((this.unit === TemperatureUnits.CELSIUS && targetUnit === TemperatureUnits.FAHRENHEIT)) {
            return (this.number * (9 / 5)) + 32;
        }
        return this.number;
    }

    public override getConversionFactors(): UnitConversionFactorGroup {
        // Temperatures don't use a conversion factor group
        return null;
    }
}
